// #region COMPONENTS COMPOSABLES
import EditRegisterContact from '../views/edit-register-contact/EditRegisterContact.vue';
// #endregion

export default [
  {
    path: '/editar-datos-contacto',
    name: 'EditRegisterContact',
    component: EditRegisterContact,
    meta: {
      title: 'Editar datos de contacto',
      staticBreadCrumbs: [
        {
          text: 'Transporte Terrestre',
          link: 'https://www.transportes.gob.es/transporte_terrestre',
        },
        {
          text: 'Viajeros de autobús y tren',
          link: 'https://www.transportes.gob.es/transporte_terrestre#Viajeros_de_autobus_y_tren',
        },
        {
          key: 'main',
          dynamic: true,
          // text: '',
          // link: STTEDRA_URL_AMPLIFY_INFORMATION || 'https://www.transportes.gob.es/transporte_terrestre/verano-joven',
          link: '',
          route: 'Home',
        },
        {
          text: 'Editar datos de contacto',
          link: '',
        },
      ],
    },
  },
];
